'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');
var pbizServer = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);

var appDom = require('../../app-dom');

var dom;
var addToCartText;

var setupDom = function() {

	dom = {};
	dom.serviceDetail = $('.service-detail');
	dom.form = dom.serviceDetail.find('.service-detail__form');
	dom.qty = dom.form.find('.service-detail__qty');

};

var addEventHandlers = function() {

	dom.serviceDetail.off('.service_detail');
	dom.serviceDetail.on('change.service_detail', '.service-detail__option', onServiceOptionChanged);
	dom.serviceDetail.on('change.service_detail', '.service-detail__qty', onQtyChanged);
	dom.serviceDetail.on('click.service_detail', '.js-add-to-cart', onAddToCartBtnClicked);
	appDom.document.off('.service_detail');
	appDom.document.on('cart_item_qty_changed.service_detail', onQtyChanged);

};

var grabFormData = function(formArray) {

	var returnArray = {};

	for (var i = 0; i < formArray.length; i++){
		returnArray[formArray[i]['name']] = formArray[i]['value'];
	}

	return returnArray;

};

var onAddToCartBtnClicked = function(e) {

	var $btn = $(this);

	dom.form = $btn.parents('.service-detail__form');

	var data = grabFormData(dom.form.serializeArray());

	addToCartText = $btn.text();

	$btn.text(pbizServer.content['Generic.Loading']);

	// add some custom goodies
	// data['sku'] = $btn.attr('data-sku') ? $btn.attr('data-sku') : '';
	data['sourceUrl'] = $btn.attr('data-item-url');

	e.preventDefault();

	$.ajax({
		url: '/index.cfm?action=cart.add',
		method: 'POST',
		dataType: 'JSON',
		data: data
	}).done(onAddToCartLinkClickedDone);

};


var onAddToCartLinkClickedDone = function(response) {

	if (response.status.code) {

		triggerCustomEvent('item_added_to_cart');

		onItemAddedToCart();

	} else {

		dom.form.find('.service-detail__add-to-cart-btn').text(addToCartText);

		notify.show({
			target: $('[name="' + response.target + '"]'),
			msg: response.status.msg,
			closeOnClick: true
		});

	}

};


var onItemAddedToCart = function() {

	notify.hide();

	resetServiceForm();

};

var resetServiceForm = function() {

	console.log('reset the product form');
	console.log(dom.form.length);

	var $selectBoxes = dom.form.find('select');
	var $textInputs = dom.form.find('input[type="text"]');
	var $textareas = dom.form.find('textarea');
	var $addToCartBtn = dom.form.find('.service-detail__add-to-cart-btn');

	$selectBoxes.each(function(i, el) {

		$(el).find('option:eq(0)').attr('selected', 'selected');

	});

	$textInputs.each(function(i, el) {

		$(el).val('');

	});

	$textareas.each(function(i, el) {

		$(el).val('');

	});

	loadServiceForm();

};

var onServiceOptionChanged = function() {

	var $selectedOption = $(this).find('option:selected');

	dom.form = $(this).parents('.service-detail__form');

	notify.hide();

	loadServiceForm();

};

var onQtyChanged = function() {

	console.log('detail-form qty changed yo!');
	console.log($(this).parents('.service-detail__form').length);

	dom.form = $(this).parents('.service-detail__form');

	notify.hide();

	loadServiceForm();

};

var loadServiceForm = function(isInitialLoad) {

	isInitialLoad = typeof isInitialLoad !== 'undefined' ? isInitialLoad : false;

	dom.form.each(function(i, el, a) {

		console.log(el);

		$.ajax({
			url: '/index.cfm?action=service.detailForm',
			method: 'POST',
			data: dom.form.eq(i).serialize() + '&isInitialLoad=' + isInitialLoad
		}).done(onLoadProductFormDone);

	});

};

var onLoadProductFormDone = function(response) {

	var $cachedForm = dom.form;

	if (response.status) {

		dom.form.filter('[data-item-id=' + response.itemId + ']').html(response.markup);

		setupDom();

		addEventHandlers();

	}

};

var init = function() {

	setupDom();

	addEventHandlers();

	loadServiceForm(true);

};

module.exports = {
	init: init
};
